module.exports = __webpack_public_path__ + "media/images/temp/ribbon-4-98a605c0b54dcdeca3719a02143cf07a.png";